import { render, staticRenderFns } from "./AlertsTab.vue?vue&type=template&id=a22de2a4&scoped=true&"
import script from "./AlertsTab.vue?vue&type=script&lang=ts&"
export * from "./AlertsTab.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsTab.vue?vue&type=style&index=0&id=a22de2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22de2a4",
  null
  
)

export default component.exports